import { Avatar, Box, Burger, Button, Group, Menu, Text, Title } from "@mantine/core";
import { IconLogout, IconUser } from "@tabler/icons-react";
import { useAuth } from "@/lib/auth";
import { ThemeSwitch } from "@/components/ThemeSwitch";

export function Topbar({ opened, toggle }: { opened: boolean; toggle: () => void }) {
  const { user, logout } = useAuth();
  const initials = user?.full_name
    ? user.full_name
        .split(" ")
        .slice(0, 2)
        .map((p) => p[0])
        .join("")
        .toUpperCase()
    : "?";
  return (
    <Group justify="space-between" h="100%" px="md">
      <Group gap="md">
        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
        <Title order={4}>EuroMarket</Title>
      </Group>
      <Group>
        <ThemeSwitch />
        {user && (
          <Menu shadow="md" width={220} position="bottom-end">
            <Menu.Target>
              <Button variant="subtle" leftSection={<Avatar size={28} radius="xl" color="brand">{initials}</Avatar>}>
                <Box style={{ textAlign: "left" }}>
                  <Text size="sm" fw={500}>{user.full_name}</Text>
                  <Text size="xs" c="dimmed">{user.role_code}</Text>
                </Box>
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item leftSection={<IconUser size={14} />} disabled>
                Профиль (скоро)
              </Menu.Item>
              <Menu.Item
                leftSection={<IconLogout size={14} />}
                color="red"
                onClick={() => void logout()}
              >
                Выйти
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        )}
      </Group>
    </Group>
  );
}
